import {
  UserProfileActions,
  UserProfileTypes,
} from '@modules/user-profile/store/userProfile.action';
import { Device } from '@codegen';

export class UserProfileState {
  public devicesList: Device[];
}

export function reducer(
  state = new UserProfileState(),
  action: UserProfileActions
): UserProfileState {
  switch (action.type) {
    case UserProfileTypes.SetActiveDevices: {
      return {
        ...state,
        devicesList: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
